/* Artículo: ids en los encabezados (slug sin tildes, como el React), índice con scroll spy y barra de progreso. */
(() => {
  const rte = document.querySelector('[data-rte]');
  if (!rte) return;
  const slug = (t) => t.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'seccion';
  const used = new Set();
  const heads = [...rte.querySelectorAll('h2, h3')];
  heads.forEach((h) => {
    if (h.id) { used.add(h.id); return; }
    let id = slug(h.textContent); let n = 2;
    while (used.has(id)) id = `${slug(h.textContent)}-${n++}`;
    used.add(id); h.id = id;
  });

  const toc = document.querySelector('[data-toc]');
  if (toc && heads.length >= 2) {
    const ul = toc.querySelector('ul');
    const links = heads.map((h) => {
      const li = document.createElement('li');
      if (h.tagName === 'H3') li.style.paddingLeft = '12px';
      const a = document.createElement('a');
      a.href = `#${h.id}`; a.textContent = h.textContent;
      a.className = 'block text-sm py-1 transition-colors duration-200 truncate text-muted-foreground hover:text-foreground';
      li.append(a); ul.append(li);
      return a;
    });
    toc.hidden = false;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        links.forEach((a) => {
          const on = a.hash === `#${e.target.id}`;
          a.classList.toggle('text-foil-400', on); a.classList.toggle('font-medium', on);
          a.classList.toggle('text-muted-foreground', !on);
          if (on) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
        });
      });
    }, { rootMargin: '-80px 0px -70% 0px' });
    heads.forEach((h) => io.observe(h));
  }

  const bar = document.querySelector('[data-read-progress] > div');
  if (bar && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let ticking = false;
    addEventListener('scroll', () => {
      if (ticking) return; ticking = true;
      requestAnimationFrame(() => {
        const max = document.documentElement.scrollHeight - innerHeight;
        bar.style.transform = `scaleX(${max > 0 ? Math.min(1, scrollY / max) : 0})`;
        ticking = false;
      });
    }, { passive: true });
  }
})();
